import {
  INIT_IDE,
  INIT_SIGNOUT,
  INIT_CHAPTER_LIST,
  CHANGE_STATEMENT,
  SAVE_CODE,
  CHANGE_ACTIVE_MODULE,
  SET_CHALLENGE_PROGRESSID,
  SAVE_TESTCASE_RESPONSES,
  TESTCASE_COMPLETED,
} from '../Actions/actionTypes';

const INIT_STATE = {
  question: [],
  value: 0,
  progressID: null,
  isPreviouslyCompleted: false,
  points: 0,
};

const IDE = (state = INIT_STATE, action) => {
  switch (action.type) {
    case INIT_IDE:
      return {
        ...state,
        question: action.question,
        points: action.points,
        isPreviouslyCompleted: action.isPreviouslyCompleted,
      };

    case INIT_SIGNOUT:
      return INIT_STATE;

    case CHANGE_STATEMENT:
      return {
        ...state,
        value: action.value,
      };

    case CHANGE_ACTIVE_MODULE:
    case INIT_CHAPTER_LIST:
      return {
        ...state,
        ...INIT_STATE,
      };

    case SET_CHALLENGE_PROGRESSID:
      return {
        ...state,
        progressID: action.progressID,
      };

    case SAVE_CODE:
      let ideDetails = state.response && state.response[action.id] ? state.response[action.id] : {};
      let response = { ...state.response, [action.id]: { ...ideDetails, code: action.code } };

      return {
        ...state,
        response,
      };

    case SAVE_TESTCASE_RESPONSES:
      let testCases =
        state.response && state.response[action.id] && state.response[action.id].testCases
          ? state.response[action.id].testCases
          : state.question.find(({ id }) => id === action.id).testCases;
      testCases = testCases.map((testcase) => {
        if (testcase.id === action.testCaseID) {
          return {
            ...testcase,
            status: action.status,
            programOutput: action.output,
          };
        }
        return testcase;
      });

      response = { ...state.response, [action.id]: { code: action.code, testCases: testCases } };
      return {
        ...state,
        response,
      };

    case TESTCASE_COMPLETED:
      let previousIsCompleted;
      let questionList = state.question.map((ques) => {
        if (ques._id === action.id) {
          previousIsCompleted = ques.isCompleted;
          return {
            ...ques,
            isCompleted: action.isCompleted,
          };
        }
        return ques;
      });
      let challengeCompleted = questionList.reduce((acc, { isCompleted }) => acc && isCompleted, true);
      let completed = state.isPreviouslyCompleted || challengeCompleted ? true : false;

      // let points = state.points;
      // if(!previousIsCompleted && action.isCompleted){
      //     points = points + action.ruleSets["IDE_QUESTION_SOLVED"];
      // }

      return {
        ...state,
        question: questionList,
        isCompleted: completed,
        isPreviouslyCompleted: completed,
      };

    default:
      return state;
  }
};

export default IDE;
